
(function () {
    if (document.querySelectorAll(".js-login-page").length > 0) {
        const loginPage = {
            init: function () {
                loginPage.showAlarmLoginMessage();
                loginPage.togglePasswordEye();
                document.getElementById('logInForm').addEventListener('submit', loginPage.doLoginTimeChecks)
            },
            showAlarmLoginMessage: () => {
                const Qm = loginPage.getQuerystring("m");
                if (Qm == null) return;
                let msg, errorReason;
                msg = "";
                switch (Qm) {
                    case "bad_permission":
                        msg = "I'm sorry, you tried to reach a page or an object that you do not have permission to access. If you reached this page via a bookmark, please delete your bookmark, navigate to the page that you are trying to reach, and then re-bookmark the page. If you reached this page by manually typing in a URL, you may have entered an incorrect number or the number may have changed in our records. We encourage users to use the Alarm.com site links rather than typing in URLs for this reason."
                        break;
                    case "cookies_off":
                        msg = "It appears that cookies are not enabled on your computer. Although Alarm.com does not store any personal information on your computer, your browser must have cookies enabled in order to maintain your secured identity while you are logged in."
                        break;
                    case "logout":
                        msg = "You have successfully logged out."
                        break;
                    case "no_session":
                        msg = "I'm sorry, your session has automatically timed out as a security precaution - please log in again."
                        break;
                    case "scripting_off":
                        msg = "It appears that your browser's current security settings prevent JavaScript from working correctly.  Alarm.com uses JavaScript to add functionality to our web pages and make them easier to use."
                        break;
                    case "sensors_cmd_sent":
                        msg = "A request has been sent to your system to retrieve an up-to-date sensor list.  It may take up to 2-3 minutes for this process to be completed.  After a few moments, please try to log in again."
                        break;
                    case "web_error":
                        msg = "I'm sorry, an unexpected error occurred while processing the page you requested. As a security precaution you have been automatically logged out.  If the problem persists after you log back into the site, please contact us for help in resolving this problem."
                        break;
                    case "login_fail":
                        errorReason = loginPage.getQuerystring("r")
                        if (errorReason == "lockout") {
                            msg = "As a security precaution your account has been locked out due to too many incorrect password attempts.  To unlock your account, please request a new password by filling out the 'Forgot your password' form <A href='https://www.alarm.com/forgot_logininfo.asp'>here."
                        }
                        else if (errorReason == "terminated") {
                            msg = "Your account has been terminated.  If you believe this to be in error, or if you would like to re-activate your account, please contact us."
                        }
                        else if (errorReason == "no_panel") {
                            msg = "Your control panel has not communicated with Alarm.com. Please make sure your control panel is powered on then try again. If you are still having trouble, please contact us."
                        }
                        else if (errorReason == "error") {
                            msg = "We're sorry, your account is currently unavailable. A message has automatically been sent to Technical Support to address this issue. We will contact you when the issue has been resolved. "
                        }
                        else if (errorReason == "custom") {
                            msg = getQuerystring("cm")
                        }
                        else if (errorReason == "no_match") {
                            msg = "I'm sorry, the login and/or password you entered were not correct. If you have forgotten your login or password, please contact us."
                        }
                        else {
                            msg = "I'm sorry, the login and/or password you entered were not correct. If you have forgotten your login or password, please contact us."
                        }
                        break;
                    default:
                        break;
                }
                const divMsg = document.getElementById("divAlarmMessage");
                if (divMsg != null) {
                    divMsg.innerHTML = msg;
                }
                if (msg != "") {
                    divMsg.classList.add("show");
                }
            },
            // Querystring reader
            getQuerystring: (key, default_) => {
                if (default_ == null) default_ = "";
                key = key.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
                const regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
                const qs = regex.exec(window.location.href);
                if (qs == null)
                    return default_;
                else
                    return qs[1];
            },
            togglePasswordEye: () => {
                const passwordField = document.getElementById("password");
                const togglePassword = document.querySelector(".password-toggle-icon i");

                togglePassword.addEventListener("mousedown", function (e) {
                    e.preventDefault(); 
                    if (passwordField.type === "password") {

                        passwordField.type = "text";
                        togglePassword.classList.remove("show__password");
                        togglePassword.classList.add("hide__password");
                    
                    } else {
          
                        passwordField.type = "password";
                        togglePassword.classList.remove("hide__password");
                        togglePassword.classList.add("show__password");
                      
                    }
                    
                });

            },
            
            doLoginTimeChecks: () => {
                
                const loginbox = document.getElementById('login')
                const chkremember = document.getElementById('rememberMe')
                if((loginbox != null) && (chkremember != null)){
                    const theDate = new Date();
    
                    if(document.forms['loginForm'].rememberMe.checked === true){
                        const threeMonthsLater = new Date(theDate.getTime() + 7776000000)
                        const expireDate = threeMonthsLater.toGMTString()
                        document.cookie = 'login' + loginbox.value + '; expires=' + expireDate;
                    }
                    else{
                        const passDate = new Date(theDate.getTime() - 7776000000)
                        const expireDate2 = passDate-toGMTString()
                        document.cookie = 'login' + loginbox.value + '; expires=' + expireDate2;
                    }
                }
                return true
    
            }
        };
        
        
        
        loginPage.init();
    }
 
})();

